<script setup>
import { swalError, swalSuccess } from '@/helper';
import { get_option, update_option } from '@/services/option';
import { onMounted, ref } from 'vue';


const isLoading = ref(true)
onMounted(async()=>{
  await get_latest_information()
  isLoading.value = false
})

const latest_information = ref({
  ids: '',
  title: '',
  description: ''
})

async function get_latest_information(){
  let response = await get_option('latest_information')
  if (response.error){
    swalError(response.result, true)
    return
  }

  latest_information.value = parseInfo(response.result.data) || {}
  latest_information.value.ids = response.result.data.id
}

function parseInfo(result){
  if (result.attributes.name ==  ''){
    return {title: '', description: ''} 
  }
  let parsed = {}
  try {
    parsed = JSON.parse(result.attributes.name);
  } catch (error) {
    console.error('Invalid JSON format:', error.message);
    parsed = {title: '', description: ''} 
  }
  return parsed
}

async function submitForm(type){
  if (type == 'latest_information'){
    let response = await update_option(
      latest_information.value.ids,
      {
        name: JSON.stringify(latest_information.value)
      }
    )
    if (response.error){
      swalError(response.result, true)
      return
    }
    swalSuccess('Change has been saved')
  }
}

</script>

<template>
  <loadingCard v-if="isLoading" />
  <div v-else class="card">
    <CardHeader title="General Setting"/>
    <div class="card-body">
      <form @submit.prevent="submitForm('latest_information')">
        <div class="col-8">
          <div class="mb-3">
            <label class="form-label" for="name">Latest Information Title</label>
            <input type="text" class="form-control"
              v-model="latest_information.title"
              placeholder="Latest information title"
              id="title"
            >
          </div>
        </div>
        <div class="col-8">
          <div class="mb-3">
            <label class="form-label" for="name">Latest Information Description</label>
            <textarea class="form-control" name="message" id="message" 
              cols="30" rows="10" v-model="latest_information.description"
              placeholder="Latest information description"
            ></textarea>
            <div class="form-text">
              Latest information to be displayed to client
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <button type="submit" class="btn btn-light-success">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</template>